<div *ngIf="isVisible" @alertAnimation
    class="ni-alert fixed z-50 sm:max-w-md sm:w-full max-sm:top-1 max-sm:left-1 max-sm:right-1"
    [ngClass]="[positions[position], variants[variant]]"
    [ngStyle]="positionStyles[position]">
    <div class="flex flex-row gap-3 items-center flex-1">
        <!-- Icon based on variant -->
        <div class="ni-alert__icon shrink-0" [ngClass]="'ni-alert__icon--' + variant">
            <!-- Success Icon -->
            <svg *ngIf="variant === 'success'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- Danger/Warning Icon -->
            <svg *ngIf="variant === 'danger' || variant === 'warning'" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.08333 5.75V9.08333M9.08333 12.4167H9.09167M17.4167 9.08333C17.4167 13.6857 13.6857 17.4167 9.08333 17.4167C4.48096 17.4167 0.75 13.6857 0.75 9.08333C0.75 4.48096 4.48096 0.75 9.08333 0.75C13.6857 0.75 17.4167 4.48096 17.4167 9.08333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- Info Icon -->
            <svg *ngIf="variant === 'info'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2" fill="none"/>
                <circle cx="10" cy="7" r="1" fill="currentColor"/>
                <rect x="9" y="9" width="2" height="5" rx="1" fill="currentColor"/>
            </svg>
        </div>
        <p *ngIf="message" class="ni-alert__message  font-archivo text-[16px]  font-normal flex-1">{{message}}</p>
        <ng-content *ngIf="!message"></ng-content>
    </div>
    <button type="button" class="ni-alert__close shrink-0" (click)="close()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
</div>